import Video from '@/data/Video';
import VideoData from '@/data/VideoData';
import VideoDataRelatedVideo from './VideoDataRelatedVideo';
import Videos from './Videos';

export default class UiActiveVideo {
  private _video: Video | undefined;
  private _videoData: VideoData | undefined;
  private _relatedVideos: Videos | undefined;
  
  constructor(video?: Video, videoData?: VideoData) {
    this._video = video;
    this._videoData = videoData;
  }
  public reset(): void {
    this._video = undefined;
    this._videoData = undefined;
  }
  public hasVideo(): boolean {
    return this.video !== undefined && this.videoData !== undefined;
  }
  public hasVideoMetaData(): boolean {
    return this.video !== undefined;
  }
  public get relatedVideosMi(): Array<VideoDataRelatedVideo> {
    if(this.videoData) {
      return this.videoData.relatedVideos;
    }
    return [];
  }
  public get relatedVideos(): Videos {
    if(!this._relatedVideos) {
      return new Videos(0);
    }
    return this._relatedVideos;
  }

  public set relatedVideos(videos: Videos) {
    this._relatedVideos = videos;
  }

  public get video() {
    return this._video;
  }
  public set video(value) {
    this._video = value;
  }
  public get videoData() {
    return this._videoData;
  }
  public set videoData(value) {
    this._videoData = value;
  }
  
};